import { Nav, Navbar, NavDropdown, Button } from "react-bootstrap";

function CustomHeader({ dark = false }) {
  return (
    <Navbar expand="lg" className={`p-0 position-absolute top-0 w-100`}>
      <Navbar.Brand href="#home" className="p-0">
        <img alt="Logo" width="100px" src="assets/box-logo.png"></img>
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse>
        <Nav className="mx-auto">
          <Nav.Link href="#home">About us</Nav.Link>
          <Nav.Link href="#works">How it works</Nav.Link>
          <NavDropdown title="Use cases" id="basic-nav-dropdown">
            <NavDropdown.Item href="#action/3.1">Repairer</NavDropdown.Item>
            <NavDropdown.Item href="#action/3.2">Leaser</NavDropdown.Item>
            <NavDropdown.Item href="#action/3.3">Dealer</NavDropdown.Item>
            <NavDropdown.Item href="#action/3.4">Appraiser</NavDropdown.Item>
          </NavDropdown>
          <Nav.Link href="#pricing">Pricing</Nav.Link>
          <Nav.Link href="#contact">Contact us</Nav.Link>
        </Nav>
      </Navbar.Collapse>
      <Button className="me-2 btn white">Log in</Button>
    </Navbar>
  );
}

export default CustomHeader;
